export const portalHost = process.env.REACT_APP_PORTAL_HOST!
export const agentWebSocketUrl = process.env.REACT_APP_AGENT_WEBSOCKET_URL!
export const isLocalhost = process.env.REACT_APP_IS_LOCALHOST === 'true'
